<template>
	<q-table
		ref="table"
		:data="participations"
		:columns="columns_participations"
		row-key="id"
		:pagination.sync="server_pagination"
		@request="requestParticipations"
		:loading="loading"
		:no-data-label="$t('no_data_avaliable')"
		:no-results-label="$t('no_results_found')"
		:loading-label="$t('loading_data')"
		:rows-per-page-label="$t('items_per_page')"
		:rows-per-page-options="[5, 10, 50, 100]"
		binary-state-sort
		class="q-mt-lg"
	>
		<q-tr slot="header" slot-scope="props" :props="props">
			<q-th v-for="col in props.cols" :key="col.name" :props="props">
				{{ $t(col.label) }}
			</q-th>
		</q-tr>
		<template slot="body" slot-scope="props">
			<q-tr :props="props">
				<q-td key="name" :props="props">
					{{ props.row.name }}
				</q-td>

				<q-td key="email" :props="props">
					{{ props.row.email }}
				</q-td>
				<!--
				<q-td key="is_present" :props="props">
					<q-checkbox aria-readonly="true" disable v-model="props.row.is_present" />
				</q-td>

				<q-td key="subscribe_date" :props="props">
					{{ fDate(props.row.subscribe_date) }}
				</q-td> -->
			</q-tr>
		</template>
	</q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {
	name: 'LiveClassesReportParticipations',
	props: ['load', 'id'],
	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			participations: [],
			columns_participations: [
				{
					name: 'name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'name',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				// {
				// 	name: 'is_present',
				// 	required: true,
				// 	label: 'present',
				// 	align: 'left',
				// 	field: 'is_present',
				// 	sortable: false,
				// },
				// {
				// 	name: 'subscribe_date',
				// 	required: true,
				// 	label: 'date',
				// 	align: 'left',
				// 	field: 'subscribe_date',
				// 	sortable: true,
				// },
			],
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},
	},

	methods: {
		requestParticipations({ pagination }) {
			this.participations = []
			this.loading = true
			this.server_pagination = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
				is_present: true,
			}

			this.savePagination()

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${this.id}/guests/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				//FALTA O CAMINHO DA API QUE AINDA NÃO FOI CRIADO
				.then((res) => {
					this.server_pagination.rowsNumber = res.data.count

					this.participations = res.data.results
						? res.data.results.map((e) => ({
								name: e.user.name,
								email: e.user.email,
								is_present: e.is_present,
								subscribe_date: e.subscribe_date,
						  }))
						: []

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

		loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.requestParticipations({ pagination: this.server_pagination })
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	created() {
		this.loadPagination()
		this.requestParticipations({ pagination: this.server_pagination })
	},
}
</script>

<style></style>
